// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"696":"58787f45","966":"dd569e45"}[chunkId] + ".chunk.js";
};